import { defaultEmptyValue } from '~common-helpers/index';

export function humanReadableFieldValue(value: string | number | undefined) {
    return defaultEmptyValue(value) || value;
}

